"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _badges = require("../../redux/badges/badges.types");

require("./badge.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const initialState = {};

class AddBadgeGroupModal extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;
    this.form = /*#__PURE__*/_react.default.createRef();

    this.hide = () => {
      this.props.hide();
    };

    this.onFinish = values => {
      var _a;

      if ((_a = this.props.badgeGroup) === null || _a === void 0 ? void 0 : _a.id) {
        Object.assign(values, {
          id: this.props.badgeGroup.id
        });
      }

      this.props.saveBadgeGroup(values);
      this.props.hide();
    };

    this.handleOk = () => {
      var _a;

      if ((_a = this.form) === null || _a === void 0 ? void 0 : _a.current) {
        this.form.current.validateFields().then(() => {
          confirm({
            title: 'Are you sure you want to create this badge collection?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              var _a;

              this.onFinish((_a = this.form.current) === null || _a === void 0 ? void 0 : _a.getFieldsValue());
            },

            onCancel() {}

          });
        });
      }
    };

    this.handleCancel = () => {
      confirm({
        title: 'Are you sure you want to leave this badge collection?',
        content: 'You will lose all changes',
        okText: 'Leave',
        okType: 'danger',
        onOk: () => {
          this.hide();
        },

        onCancel() {}

      });
    };
  }

  render() {
    const {
      visible,
      badgeGroup
    } = this.props;
    const {} = this.state;
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      className: "",
      title: "Add Badge Group",
      width: "45%",
      visible: visible,
      onOk: this.handleOk,
      onCancel: this.handleCancel,
      destroyOnClose: true
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "form",
      initialValues: badgeGroup,
      onFinish: this.onFinish
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Label",
      name: "label",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "This is the label the user's will see on the badge"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Description",
      name: "description",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "This is the Description the user's will see on the badge"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Sequence",
      name: "sequence",
      rules: [{
        required: true
      }]
    }, /*#__PURE__*/_react.default.createElement(_inputNumber.default, null))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  badges: selectors.getBadges,
  badgeGroup: selectors.getRequestedBadgeGroup
});

const mapDispatchToProps = dispatch => {
  return {
    saveBadgeGroup: badgeGroup => dispatch(_badges.saveBadgeGroupAsync.request(badgeGroup))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddBadgeGroupModal);

exports.default = _default;